export const sharedEnvironment = {
  'appVersion': '1.0.0',
  'title': 'Leclanché EMS'
}

export default sharedEnvironment;